// Any modules that should be added to the wrapper application's AppModule
// should be exported here as an array.
//
// This is useful for when you have named router-outlets used inside dialogs.

import { RequestCardsModule } from '@review/modules/request-cards/request-cards.module';
import { ManageCardsModule } from '@review/modules/manage-cards/manage-cards.module';

export default [RequestCardsModule, ManageCardsModule];
